import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import axios from "axios";
// New imports for Excel & PDF export
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";  
import QRCode from "qrcode";

const StallList = () => {
  const [stalls, setStalls] = useState([]);
  const [error, setError] = useState(null);
  const [isEditOpen, setIsEditOpen] = useState(false);
const [editStall, setEditStall] = useState(null);
const [newLogoFile, setNewLogoFile] = useState(null);
const [logoPreview, setLogoPreview] = useState("");

  const hasFetched = useRef(false);
  const API_BASE_URL =
    process.env.NODE_ENV === "development"
      ? ""
      : "https://krushiapp.dindoripranit.org";

  // Search & Pagination states (already added before)
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const FRONTEND_BASE_URL = window.location.origin;


  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    axios
      .get(`${API_BASE_URL}/api/v1/stall/list`)
      .then((res) => {
        const data = res.data?.value;

        if (!Array.isArray(data)) {
          throw new Error("API did not return an array");
        }

        const mappedStalls = data.map((s) => ({
          id: s.stallId,
          stallNo: s.stallNo,
          stallTitle: s.title,
          owner: s.stallOwner,
          description: s.description,
          logo: s.logoPhoto,
          contact: s.contactNo,
          website: s.website,
          address: s.address,
        }));

        setStalls(mappedStalls);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to fetch stall list.");
      });
  }, [API_BASE_URL]);

  const updateStall = async (stall) => {
  try {
    const payload = {
      stallId: stall.id,
      stallNo: stall.stallNo,
      title: stall.stallTitle,
      stallOwner: stall.owner,
      description: stall.description,
      logoPhoto: stall.logo,
      contactNo: stall.contact,
      website: stall.website,
      address: stall.address,
    };

    await axios.post(
      `${API_BASE_URL}/api/v1/stall/update`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    alert("Stall updated successfully");
  } catch (err) {
    console.error(err);
    alert("Failed to update stall");
  }
};

  // Handle CSV/Excel file import
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (fileExtension === "csv") {
      handleCSVImport(file);
    } else if (fileExtension === "xlsx" || fileExtension === "xls") {
      handleExcelImport(file);
    } else {
      setError("Invalid file type. Please upload a CSV or Excel file.");
    }
  };

  
  // Handle CSV Import
  const handleCSVImport = (file) => {
    Papa.parse(file, {
      complete: (result) => {
        const newStalls = result.data.map((row) => ({
          stallNo: row[0],
          stallTitle: row[1],
          owner: row[2],
          description: row[3],
          logo: row[4],
          contact: row[5],
          website: row[6],
          address: row[7],
        }));
        updateData(newStalls);
      },
      header: false,
    });
  };

  // Handle Excel Import
  const handleExcelImport = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

      const newStalls = jsonData.map((row) => ({
        stallNo: row[0],
        stallTitle: row[1],
        owner: row[2],
        description: row[3],
        logo: row[4],
        contact: row[5],
        website: row[6],
        address: row[7],
      }));
      updateData(newStalls);
    };
    reader.readAsBinaryString(file);
  };

  // Update Data
  const updateData = (newStalls) => {
    const updatedStalls = [...stalls, ...newStalls];
    setStalls(updatedStalls);
    fetch("/update-data", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedStalls),
    })
      .then((response) => response.json())
      .then(() => {
        alert("Data imported successfully!");
      })
      .catch((err) => {
        console.error("Error saving data:", err);
        setError("Failed to update data.");
      });
  };
const handleDelete = async (stallId) => {
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this stall?"
  );

  if (!confirmDelete) return;

  try {
    await axios.post(
      `https://krushiapp.dindoripranit.org/api/v1/stall/delete/${stallId}`,
      {},
      { headers: { accept: "*/*" } }
    );

    alert("Stall deleted successfully!");

    setStalls((prev) =>
      prev.filter((stall) => stall.id !== stallId)
    );
  } catch (error) {
    console.error("Delete failed:", error);
    alert("Failed to delete stall.");
  }
};

   const filteredStalls = stalls.filter((stall) =>
    stall.stallTitle?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredStalls.length / itemsPerPage);
  const paginatedStalls = filteredStalls.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // ==================== DOWNLOAD EXCEL ====================
  const downloadExcel = () => {
    const dataForExcel = filteredStalls.map((stall) => ({
      "Stall No": stall.stallNo,
      "Stall Title": stall.stallTitle || "",
      Owner: stall.owner || "",
      Description: stall.description || "",
      Contact: stall.contact || "",
      Website: stall.website || "",
      Address: stall.address || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stalls");

    // Auto-size columns
    const colWidths = [
      { wch: 12 },
      { wch: 30 },
      { wch: 20 },
      { wch: 50 },
      { wch: 15 },
      { wch: 30 },
      { wch: 40 },
    ];
    worksheet["!cols"] = colWidths;

    XLSX.writeFile(workbook, `JKM_Stall_List_2026_${new Date().toISOString().slice(0,10)}.xlsx`);
  };

// ==================== DOWNLOAD PDF (FULLY WORKING 2025) ====================
const downloadPDF = () => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4",
  });

  // Title
  doc.setFontSize(18);
  doc.text("JKM Stall List 2026 - Complete Data", 14, 15);

  // Prepare rows
  const tableRows = filteredStalls.map((stall) => [
    stall.stallNo || "",
    stall.stallTitle || "",
    stall.owner || "",
    stall.description
      ? stall.description.length > 120
        ? stall.description.substring(0, 120) + "..."
        : stall.description
      : "",
    stall.contact || "",
    stall.website || "",
    stall.address || "",
  ]);

  // ← THIS IS THE ONLY LINE THAT MATTERS
  autoTable(doc, {
    head: [["Stall No", "Stall Title", "Owner", "Description", "Contact", "Website", "Address"]],
    body: tableRows,
    startY: 25,
    styles: { fontSize: 9, cellPadding: 4 },
    headStyles: { fillColor: [22, 160, 133], textColor: 255, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 45 },
      2: { cellWidth: 35 },
      3: { cellWidth: 60 },
      4: { cellWidth: 25 },
      5: { cellWidth: 40 },
      6: { cellWidth: 50 },
    },
  });

  // Save file
  const today = new Date().toISOString().slice(0, 10);
  doc.save(`JKM_Stall_List_2026_${today}.pdf`);
};
const downloadQR = async (stallNo) => {
  try {
    const stall = stalls.find((s) => s.stallNo === stallNo);
    if (!stall) return;

    const canvas = document.createElement("canvas");

    // ===== BASE SIZE =====
    const SCALE = 3;
    const BASE_WIDTH = 1240;
    const BASE_HEIGHT = 1754;

    canvas.width = BASE_WIDTH * SCALE;
    canvas.height = BASE_HEIGHT * SCALE;

    const ctx = canvas.getContext("2d");
    ctx.scale(SCALE, SCALE);

    // ===== LOAD BACKGROUND =====
    const bgImg = new Image();
    bgImg.crossOrigin = "anonymous";
    bgImg.src = `/assets/images/Stall_QR.jpeg`;

    await new Promise((resolve, reject) => {
      bgImg.onload = resolve;
      bgImg.onerror = reject;
    });

    ctx.drawImage(bgImg, 0, 0, BASE_WIDTH, BASE_HEIGHT);

    // =================================================
    // 1️⃣ STALL TITLE — EXACT MARKED LOCATION
    // =================================================
    ctx.fillStyle = "#1b5e20";
    ctx.textAlign = "center";
// =================================================
// 1️⃣ STALL TITLE WITH AUTO-FIT + BRACKETS
// =================================================
const title = stall.stallTitle || "";

// 🔒 SAFE AREA
const SAFE_PADDING = 80;
const MAX_WIDTH = BASE_WIDTH - (SAFE_PADDING * 2);

const MAX_FONT = 80;
const MIN_FONT = 38;

ctx.fillStyle = "#1b5e20";
ctx.textAlign = "center";
ctx.textBaseline = "middle";

let fontSize = MAX_FONT;

// Auto-scale title font
do {
  ctx.font = `bold ${fontSize}px Arial`;
  fontSize -= 2;
} while (
  ctx.measureText(title).width > MAX_WIDTH * 0.82 && 
  fontSize > MIN_FONT
);

// Final font
ctx.font = `bold ${fontSize}px Arial`;

const CENTER_X = BASE_WIDTH / 2;
const TITLE_Y = 480;

// ---- Draw title ----
ctx.fillText(title, CENTER_X, TITLE_Y);

// ---- Measure title width ----
const titleWidth = ctx.measureText(title).width;

// ---- Bracket spacing ----
const BRACKET_GAP = 18;

// ---- Draw brackets ----
ctx.font = `bold ${fontSize}px Arial`;

ctx.fillText(
  "(",
  CENTER_X - titleWidth / 2 - BRACKET_GAP,
  TITLE_Y
);

ctx.fillText(
  ")",
  CENTER_X + titleWidth / 2 + BRACKET_GAP,
  TITLE_Y
);

    // =================================================
    // 2️⃣ QR CODE — INSIDE GREEN BOX (PERFECT)
    // =================================================
    const qrUrl = `${FRONTEND_BASE_URL}/#/stall/${stallNo}`;

    const qrDataUrl = await QRCode.toDataURL(qrUrl, {
      width: 1000,
      margin: 1,
      errorCorrectionLevel: "H",
    });

    const qrImg = new Image();
    qrImg.src = qrDataUrl;
    await new Promise((resolve) => (qrImg.onload = resolve));

    // ---- FINAL QR SIZE & POSITION (DO NOT CHANGE) ----
    const QR_SIZE = 780;        // fits inside brackets
    const QR_X = (BASE_WIDTH - QR_SIZE) / 2;
    const QR_Y = 750;           // centered in green box

    // white padding for scan clarity
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(QR_X - 20, QR_Y - 20, QR_SIZE + 40, QR_SIZE + 40);

    ctx.drawImage(qrImg, QR_X, QR_Y, QR_SIZE, QR_SIZE);

    // =================================================
    // 3️⃣ DOWNLOAD
    // =================================================
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png", 1.0);
    link.download = `Stall_${stallNo}_QR.png`;
    link.click();
  } catch (err) {
    console.error("QR generation failed", err);
    alert("Failed to generate QR");
  }
};



const parseStallNo = (stallNo = "") => {
  const dome = stallNo.match(/[A-Za-z]+/)?.[0] || "";
  const numbers = stallNo.match(/\d+([,-]\d+)*/)?.[0] || "";

  return {
    domeNo: dome,
    stallNumbers: numbers.replace("-", " to "),
  };
};
const downloadInvitation = async (stall) => {
  const doc = new jsPDF("portrait", "mm", "a4");

  const { domeNo, stallNumbers } = parseStallNo(stall.stallNo);

  // Background Image
  const bgImg = "/assets/images/stall_invitation_page.jpg"; // put image in public folder
  doc.addImage(bgImg, "JPEG", 0, 0, 210, 297);

  // Stall Logo (circle)
  if (stall.logo) {
    doc.addImage(stall.logo, "PNG", 20, 90, 50, 50, undefined, "FAST");
  }

  // Stall Title
  doc.setFontSize(22);
  doc.setTextColor(0, 100, 0);
  doc.text(stall.stallTitle || "", 105, 150, { align: "center" });

  // Dome & Stall No
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  doc.text(`Dome No: ${domeNo}`, 105, 165, { align: "center" });
  doc.text(`Stall No: ${stallNumbers}`, 105, 175, { align: "center" });

  doc.save(`Invitation_Stall_${stall.stallNo}.pdf`);
};

const CertificateIcon = ({ size = 22, color = "#1b5e20" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: "block" }}
  >
    <path d="M26 36H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2h-8M12 14h24m-24 7h6m-6 7h4" />
    <path d="M30 33a6 6 0 1 0 0-12a6 6 0 0 0 0 12Z" />
    <path d="m30 40l4 2V31.472S32.86 33 30 33s-4-1.5-4-1.5V42z" />
  </svg>
);


  return (
    <div style={{ padding: "20px" }}>
<style jsx>{`
  .table-container {
    overflow-x: auto;
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
  }

  .table-container table {
    border-collapse: collapse;
    width: 100%;
    background: white;
  }

  .table-container th,
  .table-container td {
    text-align: left;
    padding: 12px;
    border: 1px solid #ddd;
  }

  .table-container th {
    background-color: #f2f2f2;
    font-weight: bold;
    position: sticky;
    top: 0;
    z-index: 2;
  }
      /* Mobile responsiveness for pagination */
  @media (max-width: 768px) {
    .mobile-break {
      display: block;
    }
  }

  @media (min-width: 769px) {
    .mobile-break {
      display: none;
    }
  }

  /* Make buttons easier to tap on mobile */
  button {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
  }
`}</style>
      <h2>|| श्री स्वामी समर्थ गुरुमाऊली ||</h2>
      <h3>JKM Stall List 2026</h3>

      {/* Buttons Row */}
      <div style={{ marginBottom: "20px", display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
        <Link to="/register">
          <button style={{ padding: "10px 20px" }}>Register New Stall</button>
        </Link>

        <input
          type="file"
          accept=".csv, .xlsx, .xls"
          onChange={handleFileUpload}
          style={{ padding: "10px" }}
        />

        {/* NEW DOWNLOAD BUTTONS */}
        <button onClick={downloadExcel} style={{ padding: "10px 20px", background: "#28a745", color: "white", border: "none" }}>
          Download Excel
        </button>
        <button onClick={downloadPDF} style={{ padding: "10px 20px", background: "#dc3545", color: "white", border: "none" }}>
          Download PDF
        </button>
      </div>

      {/* Search Box */}
      <div style={{ marginBottom: "20px" }}>
        <input
          type="text"
          placeholder="Search by Stall Title..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          style={{ padding: "10px", width: "300px", fontSize: "16px" }}
        />
        <span style={{ marginLeft: "10px", fontWeight: "bold" }}>
          Total Stalls: {filteredStalls.length}
        </span>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}
<div className="table-container">
      <table border="1" width="100%" cellPadding="10">
        <thead>
          <tr>
            <th>Stall No</th>
            <th>Title</th>
            <th>Owner</th>
            <th>Address</th>
            <th>Click Here</th>
             <th>Stall QR</th>
             <th>Invitation</th>
             <th>Update</th>
             <th>Delete</th>


          </tr>
        </thead>
        <tbody>
  {paginatedStalls.map((stall, index) => (
    <tr key={`${stall.stallNo}-${index}`}>
      <td>{stall.stallNo}</td>
      <td>{stall.stallTitle}</td>
      <td>{stall.owner || "N/A"}</td>
      <td>{stall.address || "N/A"} </td>
      <td>
        <Link to={`/stall/${stall.stallNo}`}>Click Here</Link>
      </td>
      <td>
        <button
          onClick={() => downloadQR(stall.stallNo)}
          style={{
            padding: "6px 10px",
            background: "#0d6efd",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          Make QR
        </button>
      </td>
   <td>
  <button
    onClick={() =>
      window.open(`/#/invitation/${stall.stallNo}`, "_blank")
    }
    title="Open Invitation"
    style={{
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: 4,
    }}
  >
    <CertificateIcon size={22} />
  </button>
</td>


      <td>
  <button
    onClick={() => {
      setEditStall(stall);
      setLogoPreview(stall.logo || "");
      setIsEditOpen(true);
    }}
    style={{
      padding: "6px 10px",
      background: "#198754",
      color: "#fff",
      border: "none",
      cursor: "pointer",
    }}
  >
    Update
  </button>
</td>
<td>
  <button
    onClick={() => handleDelete(stall.id)}
    style={{
      backgroundColor: "red",
      color: "white",
      border: "none",
      padding: "6px 10px",
      cursor: "pointer",
    }}
  >
    Delete
  </button>
</td>


    </tr>
  ))}
</tbody>
      </table>
</div>

{/* Pagination - Enhanced with better visibility */}
{/* Pagination - Always show info, buttons only when needed */}
{/* Pagination - Mobile Responsive */}
<div
  style={{
    width: "100%",
    padding: "15px 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    zIndex: 10,
    background: "#f8f9fa",
    marginTop: "20px",
    borderTop: "2px solid #ddd",
    minHeight: "60px",
  }}
>
  <div
    style={{
      display: "flex",
      gap: "8px",
      alignItems: "center",
      flexWrap: "wrap",
      justifyContent: "center",
      maxWidth: "100%",
    }}
  >
    {/* Previous button */}
    <button
      onClick={() => goToPage(currentPage - 1)}
      disabled={currentPage === 1}
      style={{
        padding: "10px 16px",
        cursor: currentPage === 1 ? "not-allowed" : "pointer",
        opacity: currentPage === 1 ? 0.5 : 1,
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        fontWeight: "bold",
        fontSize: "14px",
        minWidth: "80px",
        touchAction: "manipulation", // Better mobile tap
      }}
    >
      ← Prev
    </button>

    {/* Page info - responsive text */}
    <span
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        margin: "0 5px",
        color: "#333",
        textAlign: "center",
        whiteSpace: "nowrap",
      }}
    >
      <span style={{ display: "inline-block" }}>
        Page <strong style={{ color: "#007bff" }}>{currentPage}</strong> of{" "}
        <strong style={{ color: "#007bff" }}>{totalPages}</strong>
      </span>
      <br className="mobile-break" />
      <span
        style={{
          color: "#666",
          fontSize: "12px",
          display: "inline-block",
          marginTop: "2px",
        }}
      >
        ({filteredStalls.length} stalls)
      </span>
    </span>

    {/* Next button */}
    <button
      onClick={() => goToPage(currentPage + 1)}
      disabled={currentPage === totalPages}
      style={{
        padding: "10px 16px",
        cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        opacity: currentPage === totalPages ? 0.5 : 1,
        background: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "4px",
        fontWeight: "bold",
        fontSize: "14px",
        minWidth: "80px",
        touchAction: "manipulation", // Better mobile tap
      }}
    >
      Next →
    </button>
  </div>
</div>
     {isEditOpen && editStall && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 99999, // Changed from 9999
      overflowY: "auto",
    }}
  >
    <div style={{ background: "#fff", padding: "20px", width: "500px" }}>
      <h3>Edit Stall</h3>
stall No:
      <input
  value={editStall.stallNo}
  onChange={(e) =>
    setEditStall({ ...editStall, stallNo: e.target.value })
  }
  placeholder="Stall No"
  style={{ width: "100%", marginBottom: "10px" }}
/>
      stall title:
      <input
        value={editStall.stallTitle}
        onChange={(e) => setEditStall({ ...editStall, stallTitle: e.target.value })}
        placeholder="Stall Title"
        style={{ width: "100%", marginBottom: "10px" }}
      />
stall owner :
      <input
        value={editStall.owner}
        onChange={(e) => setEditStall({ ...editStall, owner: e.target.value })}
        placeholder="Owner"
        style={{ width: "100%", marginBottom: "10px" }}
      />
contact number :
      <input
        value={editStall.contact}
        onChange={(e) => setEditStall({ ...editStall, contact: e.target.value })}
        placeholder="Contact"
        style={{ width: "100%", marginBottom: "10px" }}
      />

      {logoPreview && (
        <img src={logoPreview} alt="logo" width="100" />
      )}
      <input
        type="file"
        accept="image/*"
        onChange={(e) => {
          const file = e.target.files[0];
          if (!file) return;

          const reader = new FileReader();
          reader.onloadend = () => {
            setEditStall({ ...editStall, logo: reader.result });
            setLogoPreview(reader.result);
          };
          reader.readAsDataURL(file);
        }}
      />
stall description:
      <textarea
        value={editStall.description}
        onChange={(e) => setEditStall({ ...editStall, description: e.target.value })}
        placeholder="Description"
        style={{ width: "100%", marginBottom: "10px" }}
      />

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button onClick={() => setIsEditOpen(false)}>Cancel</button>

        <button
          onClick={() => {
            updateStall(editStall);

            setStalls((prev) =>
              prev.map((s) => (s.id === editStall.id ? editStall : s))
            );

            setIsEditOpen(false);
            setEditStall(null);
          }}
          style={{ background: "#198754", color: "#fff" }}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default StallList;